angular.module("acl.common.event", ["acl.common.config"]);
